const scrollHelper = {
    scrollTo (offset, speed = 1000) {
        $('html, body').animate({
            scrollTop: Math.max(0, offset - 100)
        }, speed)
    },
}

export let scrollTo = scrollHelper.scrollTo

export default scrollHelper
